import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { Moment } from 'moment';

@Component({
  selector: 'kt-export-date-range-dialog',
  templateUrl: './export-date-range-dialog.component.html',
  styleUrls: ['./export-date-range-dialog.component.scss']
})
export class ExportDateRangeDialogComponent implements OnInit {

  // Inputs in YYYY-MM-DD format from the parent component
  @Input() currentStartDate: string;
  @Input() currentEndDate: string;

  selectedDates: { startDate: Moment, endDate: Moment };
  maxDate: Moment;
  hasError = false;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
    this.maxDate = moment();

    if (this.currentStartDate && this.currentEndDate) {
      this.selectedDates = {
        startDate: moment(this.currentStartDate, 'YYYY-MM-DD'),
        endDate: moment(this.currentEndDate, 'YYYY-MM-DD')
      };
    } else if (this.currentStartDate) {
      this.selectedDates = {
        startDate: moment(this.currentStartDate, 'YYYY-MM-DD'),
        endDate: moment(this.currentStartDate, 'YYYY-MM-DD')
      };
    } else {
      this.selectedDates = {
        startDate: moment().startOf('month'),
        endDate: moment()
      };
    }
  }

  onDateRangeChange(e) {
    // ngx-daterangepicker-material updates selectedDates via ngModel
  }

  onExport() {
    if (!this.selectedDates || !this.selectedDates.startDate || !this.selectedDates.endDate) {
      this.hasError = true;
      return;
    }

    this.activeModal.close({
      startDate: this.selectedDates.startDate.format('YYYY-MM-DD'),
      endDate: this.selectedDates.endDate.format('YYYY-MM-DD')
    });
  }
}
